<template>
	<div class="col-sm-12 col-xs-12">
		<div class="panel panel-default border-panel card-view panel-refresh" style='margin-bottom: 17px; height: 344px;'>
      <div class="panel-heading">
        <div class="pull-left">
          <h6 class="panel-title txt-dark">{{this.$t('app.dashboard.pieChartTitle')}}</h6>
        </div>
        <div class="clearfix">
        </div>
      </div>
			<div :class="!pieChartSum ? 'no-data' : ''">
      	<apexchart v-if="pieChartSum" type="pie" :options="options" :series="series" :height="options.height"></apexchart>
         <span v-if="!pieChartSum" class="txt-dark">{{this.$t('app.dashboard.noData')}}</span>
    	</div>
		</div>
	</div>
</template>
<script>
import ApexCharts from 'apexcharts'
import { mapActions, mapGetters } from "vuex";
export default {
  name: "PieChart",
  components: {
		ApexCharts
  },
  props: {
		options: {
      type: Object,
      required: true
    },
		series: {
      type: Array,
      required: true
    },
    minHeight: {
      type: Number,
      default: 344,
    }
	},
  data() {
    return {
			
		};
  },
  computed: {
    pieChartSum() {
      let sum = 0
      this.series.forEach(seria => {
        sum += seria
      })

      if (sum !== 0)  {
        return true
      } else {
        return false
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions({
    }),
	}
};
</script>

<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #272B34 !important;
  line-height: 24px;
  font-weight: 700;
}

.no-data {
  padding: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/dashboard/PieChart.vue